import { render } from "./DuelsUserElement.vue?vue&type=template&id=e7783f92&scoped=true"
import script from "./DuelsUserElement.vue?vue&type=script&lang=js"
export * from "./DuelsUserElement.vue?vue&type=script&lang=js"

import "./DuelsUserElement.vue?vue&type=style&index=0&id=e7783f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7783f92"]])

export default __exports__